module.exports = "/images/ny-street-11.jpg";